module.exports = __webpack_public_path__ + "img/policy.cfad03b.png";